/**
 * Display text for the f11.3 rail entry. Pure formatting of server facts --
 * no rule about who may see or edit what lives here.
 */

import type { CycleInputEntry, CycleInputEntryUnit } from '@/api/client';

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** "214 lines · 214 editable · USD", or "96 lines · read only · USD". */
export function unitMeta(unit: CycleInputEntryUnit, mode: 'INPUT' | 'VIEW' | null): string {
  const lines = `${unit.line_count} ${unit.line_count === 1 ? 'line' : 'lines'}`;
  const editing =
    mode === 'INPUT' && unit.editable_line_count > 0 ? `${unit.editable_line_count} editable` : 'read only';
  return `${lines} · ${editing} · ${unit.reporting_currency_code}`;
}

/** "Open for input — Aug–Dec 2026", or "Read only — cycle is Frozen". */
export function inputEntryFoot(input: CycleInputEntry): string {
  const { cycle, entry } = input;
  if (entry.mode === 'INPUT') {
    return cycle.open_window ? `Open for input — ${cycle.open_window.label}` : 'Open for input';
  }
  return `Read only — cycle is ${cycle.state.name}`;
}

/** "Cycle 2607 · closing July 2026 · open window Aug–Dec 2026". */
export function inputEntrySubtitle(input: CycleInputEntry): string {
  const { cycle } = input;
  const parts = [`Cycle ${cycle.code}`, `closing ${MONTH_NAMES[cycle.closing_month - 1]} ${cycle.period_year}`];
  parts.push(cycle.open_window ? `open window ${cycle.open_window.label}` : 'no open months');
  return parts.join(' · ');
}

/** The "Nothing to input" copy, naming the cycle. */
export function nothingToInput(code: string): { title: string; body: string } {
  return {
    title: `Nothing to input in cycle ${code}`,
    body: 'No delivery element in this cycle is assigned to you.',
  };
}
